// import Swiper JS
import Swiper, { Navigation , Pagination, Autoplay} from 'swiper';

( function( $ ) {

    // configure Swiper to use modules
    Swiper.use([Navigation,Pagination,Autoplay]);

    var articleSlider = new Swiper ('.articles-slider-container', {
        // Optional parameters
        direction: 'horizontal',
        loop: false,
        speed: 300,
        spaceBetween: 15,
        slidesPerView: 1.2,
        //freeMode: true,
        //freeModeMomentumRatio: 0.7,
        //freeModeMomentumVelocityRatio: 0.7,
        breakpoints: {
            992: {
                slidesPerView: 3,
                spaceBetween: 32,
            },
            768: {
                slidesPerView: 2.2,
                spaceBetween: 32,
            }
        },

        navigation: {
            nextEl: '.articles-slider-next',
            prevEl: '.articles-slider-prev',
        },
    });


    //related items slider on for example the theme detail page
    var relatedItemsSlider = new Swiper('.related-items-slider', {
        //lazyLoad: 'ondemand',//vragen daily
        pagination: {
            el: '.related-items-slider-pagination',
            type: 'bullets',
            clickable: true
        },
        loop: true,
        autoplay: false,
        autoplaySpeed: 2000,
        speed: 1000,
        slidesPerView: 1.3,
        slidesPerGroup: 1,
        passiveListeners: true, //recommended for mobile performance
        centeredSlides: false,
        breakpoints: {
            768: {
              slidesPerView: 2.7,
              slidesPerGroup: 1
            }
        },
    });
   
    var swiperSliders = {
        sliderSettings: {
            autoplay: {
                delay: 8000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.slider-pagination-dots',
                type: 'bullets',
                clickable: true
            },
            speed: 250,
            // easing: 'swing'
        },
        init: function() {
            this.initSliders();
        },
        initSliders: function() {
            var expertSlider          = new Swiper('.theme-intro .expert-slider' , this.sliderSettings);
            var trainingenQuoteSlider = new Swiper('.trainingen__quote-slider', this.sliderSettings);
            var boekenTipSlider       = new Swiper('.boekentip-slider', this.sliderSettings);

            if( $('.trainingen__quote-slider').length ) {
                this.changeColor( trainingenQuoteSlider, '.trainingen__quote' );
            }
        },
        changeColor: function( element, parent ) {
            // On before slide change
            element.on( 'slideChange', function(){
                var slide_number = this.activeIndex + 1;
                var color_number = 1;

                if( slide_number % 3 == 0 ) {
                    color_number = 3;
                } else if( slide_number % 2 == 0 ) {
                    color_number = 2;
                } else {
                    color_number = 1;
                }

                $( parent ).removeClass( 'color1' );
                $( parent ).removeClass( 'color2' );
                $( parent ).removeClass( 'color3' );
                $( parent ).addClass( 'color' + color_number );
            });
        }
    };
    swiperSliders.init();

    Swiper.use([Navigation]);

    // Swiper settings for tags on archive-advice page
    var mySwiper = new Swiper ('.swiper-container.filter-bar', {
        // Optional parameters
        direction: 'horizontal',
        slidesPerGroup: 2,
        freeMode: true,
        slidesPerView :'auto',
        loop : false,
        slidesPerViewFit : true,
        navigation: {
            nextEl: '.filter-bar-next',
            prevEl: '.filter-bar-prev',
        },
        breakpoints: {
            768: {
                slidesPerGroup: 3,
            }
        },
    });

    // Swiper settings for tags on archive-advice page
    var editieSwiper = new Swiper ('.swiper-container.editie-carousel-container', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        speed: 300,
        spaceBetween: 15,
        slidesPerView: 1.2,
        freeMode: true,
        freeModeMomentumRatio: 0.7,
        freeModeMomentumVelocityRatio: 0.7,
        breakpoints: {
            992: {
                slidesPerView: 2.4,
                spaceBetween: 30,
            },
            768: {
                slidesPerView: 1.4,
                spaceBetween: 30,
            }
        },

        navigation: {
            nextEl: '.card-slider-next',
            prevEl: '.card-slider-prev',
        },
    });

} )( jQuery );
